import { Collapse, List, ListItemButton, ListItemIcon, ListItemText, Typography, Popper, Paper } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import SidebarItem from './SidebarItem';
import { Box } from '@mui/system';
import PopupState, { bindPopper, bindHover } from 'material-ui-popup-state';
import { firstLeafPath, flattenChildren, isRouteSelected } from './sidebarNav';

/** @param depth 0 for a top-level product group, 1+ for a group nested inside one. */
const SidebarItemCollapse = ({ item, depth = 0 }) => {
  const [open, setOpen] = useState(false);
  const loaction = useLocation();
  const nested = depth > 0;
  const active = loaction.pathname.includes(item.path);

  useEffect(() => {
    if (loaction.pathname.includes(item.path)) setOpen(true);
    else setOpen(false);
  }, [loaction.pathname, item.path]);

  return item.sidebarProps ? (
    <PopupState variant="popper" popupId="expanded-sidebar-popper">
      {popupState => (
        <>
          <ListItemButton
            {...bindHover(popupState)}
            selected={active}
            component={Link}
            to={firstLeafPath(item)}
            sx={{ px: 1 }}
          >
            <ListItemIcon
              sx={{
                ...(nested ? { minWidth: 32, mr: 1 } : { mr: 2 }),
                ...(active && {
                  color: theme => theme.palette.primary.main,
                }),
                justifyContent: 'center',
              }}
            >
              {item.sidebarProps.icon && item.sidebarProps.icon}
            </ListItemIcon>
            <ListItemText
              sx={{ my: 0 }}
              primary={
                <Typography variant={nested ? 'body2' : 'body1'} fontWeight={active && 'bold'}>
                  {item.sidebarProps.displayText}
                </Typography>
              }
            />
          </ListItemButton>
          <Collapse in={open} timeout="auto">
            <List sx={{ ml: 2 }}>
              {item.child?.map(route =>
                route.sidebarProps ? (
                  route.child ? (
                    <SidebarItemCollapse item={route} depth={depth + 1} key={route.path} />
                  ) : (
                    // A leaf inside a group is one level down.
                    <SidebarItem item={route} depth={depth + 1} key={route.path} />
                  )
                ) : null,
              )}
            </List>
          </Collapse>
          {!open && (
            <Popper
              {...bindPopper(popupState)}
              placement="right-start"
              sx={{ zIndex: theme => theme.zIndex.drawer + 1 }}
            >
              <Paper
                sx={{
                  ml: 1,
                }}
              >
                <Box
                  sx={{
                    position: 'absolute',
                    top: '12px',
                    left: '0px',
                    width: '0px',
                    height: '0px',
                    borderTop: '5px solid transparent',
                    borderBottom: '5px solid transparent',
                    borderRight: theme => `8px solid ${theme.palette.primary.main}`,
                  }}
                />
                <List disablePadding sx={{ minWidth: '150px' }}>
                  {/* Flatten nested groups: a third level has no route of its own. */}
                  {flattenChildren(item.child).map((child, index) => (
                    <ListItemButton
                      key={index}
                      component={Link}
                      to={child.path}
                      selected={isRouteSelected(child, loaction.pathname)}
                      sx={{
                        borderLeft: theme => `1px solid ${theme.palette.primary.main}`,
                      }}
                    >
                      {child.sidebarProps.displayText}
                    </ListItemButton>
                  ))}
                </List>
              </Paper>
            </Popper>
          )}
        </>
      )}
    </PopupState>
  ) : null;
};

export default SidebarItemCollapse;
